<ul-chip
  [additionalClasses]="{
    neutral: !intakeType().enabled,
    green: intakeType().enabled,
  }"
  [matTooltip]="intakeType().description"
  matTooltipClass="chip-tooltip"
  matTooltipPosition="above"
>
  {{ intakeType().name }}
</ul-chip>
